import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Typography, Box, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import styles from './StreamKeysSuccess.module.scss';

const StreamKeysSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Here you could fetch session details from your API if needed
    console.log('Stream key purchase completed:', sessionId);
  }, [sessionId]);

  const handleGoToStreamKeys = (): void => {
    navigate('/stream-keys');
  };

  const handleGoToProjects = (): void => {
    navigate('/projects');
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.content}>
        <CheckCircleIcon className={styles.successIcon} />
        <Typography variant="h4" className={styles.title}>
          Stream Keys Purchased!
        </Typography>
        <Typography variant="body1" className={styles.message}>
          Your stream keys have been successfully purchased and are now available in your account.
        </Typography>
        <Box className={styles.buttonContainer}>
          <Button variant="contained" onClick={handleGoToStreamKeys} className={styles.button}>
            View Stream Keys
          </Button>
          <Button variant="outlined" onClick={handleGoToProjects} className={styles.button}>
            Go to Projects
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default StreamKeysSuccess;
